import { render, staticRenderFns } from "./ProdiodetailReport.vue?vue&type=template&id=42fe14d4"
import script from "./ProdiodetailReport.vue?vue&type=script&lang=js"
export * from "./ProdiodetailReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports